import React from 'react';

interface TeaserPlaceholderProps {
  index: number;
}

const TeaserPlaceholder: React.FC<TeaserPlaceholderProps> = ({ index }) => {

  const toplineWidth = `${index === 0 ? 80 : index === 1 ? 90 : index % 2 === 0 ? 80 : 70}%`
  const titleWidth = `${index === 0 ? 60 : index === 1 ? 70 : index % 2 === 0 ? 70 : 50}%`

  return (
    <div className="teaser teaser-minimized teaser-minimized-type-article teaser--image teaser--skeleton-loader" style={{animationDelay: `${index * 0.2}s`}}>
      <div>
        <div className="flex items-stretch">
            <div className="teaser-image fallback-image">
                
            </div>
            <div className="teaser-body flex-1">
                <div className="teaser-info">
                    <div
                      className="teaser-topline"
                    >
                        <div style={{
                        width: toplineWidth
                      }}>Topline</div>
                    </div>
                </div>
                <h3 
                  className="teaser-title"
                  style={{
                    width: titleWidth
                  }}
                >
                  Nachricht {index + 1}
                </h3>
            </div>
        </div>
    </div>
    </div>
  );
};

export default TeaserPlaceholder;
